//
// Focus errors when present
//
document.addEventListener('turbolinks:load', event => {
  const applicationPage = document.getElementsByClassName('application-form-page__content')[0]
  const override = document.getElementById('override_focus')

  if (override && override.value == 'yes') {
    return
  }

  if (applicationPage) {
    const inputs = applicationPage.getElementsByTagName('input')

    for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('focus', event => {
        event.target.scrollIntoView({ block: 'start', inline: 'start', behavior: 'smooth' })
      })
    }
  }
})

